import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import routes, { subRoutes } from '../../routes';

function BasePage() {
  return (
    <>
      <Router>
        <Box minH="100vh" bg={useColorModeValue('gray.100', 'gray.900')}>
          <Box p="4" data-testid="base-page-content-holder">
            <Routes>
              {routes.map((route, idx) => {
                return (
                  <Route
                    path={route.path}
                    element={route.component}
                    key={`${route.name}-${idx}`}
                  />
                );
              })}
              {subRoutes.map((route, idx) => {
                return (
                  <Route
                    path={route.path}
                    element={route.component}
                    key={`${route.name}-${idx}`}
                  />
                );
              })}
            </Routes>
          </Box>
        </Box>
      </Router>
    </>
  );
}

export default BasePage;
